/**
 * Safely parse json
 */
const safeParseJSON = function (str) {
  if (typeof(str) === 'undefined' && str === null) return null;

  str = str.replace(/(\w+):/g, '"$1":'); //console.log(str);

  try {
    return JSON.parse(str); //console.log(jsonObject);
  } catch (e) {
    console.error("Invalid JSON string", e);
    return null;
  }
};

export { safeParseJSON };
